<template>
	<v-main>
		<v-navigation-drawer fixed clipped permanent style="padding: 64px 0px 0px 0px;">
			<v-card flat>
				<v-card-text>
					<v-form ref="form">
						<v-text-field
							label="ID оголошення"
							v-model.trim="params.id"
							outlined
							dense
							clearable
							value="39316791"
							:rules="[rules.requiredNumber]"
							@keyup.ctrl.90="$set(params, 'id', 39316791)"
							hide-details="auto"
						></v-text-field>
					</v-form>
				</v-card-text>
			</v-card>
			<template v-slot:append>
				<v-card-actions class="px-4">
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="onClear">{{ $vuetify.lang.t('$vuetify.clear') }}</v-btn>
					<v-btn color="primary" @click="onOK">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
				</v-card-actions>
			</template>
		</v-navigation-drawer>

		<v-navigation-drawer fixed clipped permanent right
			mini-variant
			mini-variant-width="56"
			style="padding: 64px 0px 0px 0px;"
        >
			<v-list dense nav>
				<!-- PDF -->
				<v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on: tooltip, attrs }">
								<v-icon color="red" v-bind="attrs" v-on="{ ...tooltip }" @click="onPDF">mdi-file-pdf-box</v-icon>
							</template>
							<span>Експорт PDF</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item>
			</v-list>

			<v-divider></v-divider>

			<v-list dense nav>
				<v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on: tooltip, attrs }">
								<v-icon v-bind="attrs" v-on="{ ...tooltip }" @click="onDownloadAll">mdi-download</v-icon>
							</template>
							<span>Завантажити все</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item>
			</v-list>
			
        </v-navigation-drawer>

		<v-container style="padding: 64px 0px 0px 256px;">
			<v-card flat>
				<v-card-title class="font-weight-light">
					{{ title }} {{ id ? '№' + id: '' }}
				</v-card-title>
				<v-card-subtitle>{{ subtitle }}</v-card-subtitle>

				<v-divider></v-divider>

				<!-- <v-row v-for="(fotos, ekey) in data" :key="ekey"  >
					<v-col v-for="(foto, fkey) in fotos" :key="fkey"
						class="d-flex child-flex"
						cols="4"
					>
						<v-hover v-slot="{ hover }">
							<v-img
								:src="foto.formats[1]"
								aspect-ratio="1"
								class="grey lighten-2"
								contain
							>
								<v-app-bar flat color="rgba(0, 0, 0, 0)" v-if="hover">
									<v-spacer></v-spacer>
									<v-btn icon @click="onDownload(foto)">
										<v-icon>mdi-download</v-icon>
									</v-btn>
								</v-app-bar>
							</v-img>
						</v-hover>
					</v-col>
				</v-row> -->

				<v-row>
					<v-col v-for="(file, index) in files" :key="index"
						class="d-flex child-flex"
						cols="4"
					>
						<z-gallery :items="files" :selected-index="index">
							<template v-slot:activator="{ dialog, attrs }">
								<v-hover v-slot="{ hover }">
									<v-img
										:src="getFileUrl(file)"
										aspect-ratio="1"
										class="grey lighten-2"
										contain
										v-bind="attrs" v-on="dialog"
									>
										<v-app-bar flat color="rgba(0, 0, 0, 0)" v-if="hover">
											<v-spacer></v-spacer>
											<v-btn icon @click="onDownload(file)">
												<v-icon>mdi-download</v-icon>
											</v-btn>
										</v-app-bar>
									</v-img>
								</v-hover>
							</template>	
						</z-gallery>
					</v-col>
				</v-row>
				
			</v-card>
		</v-container>
		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
		<v-snackbar v-model="snackbar.visible" :color="snackbar.color">
			{{ snackbar.text }}
			<template v-slot:action="{ attrs }">
				<v-btn icon v-bind="attrs" @click="snackbar.visible = false" >
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</template>
		</v-snackbar>

		<z-pdf ref="pdf" :item="item"></z-pdf>
	</v-main>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import axios from 'axios'
import mixin from './mixin/parameters'
import zPdf from '@/views/pdf/VehicleAutoAdvertFotos'
import zGallery from '@/views/components/dialogs/Gallery'

export default {
	name: 'VehicleAutoAdvertFotos',
	mixins: [mixin],
	components: {
		zPdf, zGallery
	},
	data: () => ({
		title: 'Фотографії оголошення',
		subtitle: '',

		loading: false,

		excel: {
			name: '',
			type: 'xlsx',
			disabled: true,
			data: []
		},

		snackbar: {
			visible: false,
			text: null,
			color: null
		},
	}),
	
	computed: {
		...mapGetters('VehicleAutoAdvertFotos', [ 'item' ]),

		id() {
			return this.item?.id ? this.item.id: null;
		},

		/* data() {
			return this.item?.data ? this.item.data: [];
		}, */

		files() {
			return this.item?.files ? this.item.files : []
		},
	},

	methods: {
		...mapActions('VehicleAutoAdvertFotos', [ 'setItem' ]),

		onClear() {
			this.$refs.form.reset()
		},

		onOK() {
			var that = this
			if (this.$refs.form.validate()) {
				//console.log(this.$options.name, 'onOK', 'VALID')
				this.loading = true

				this.setItem()

				axios.post('/vehicle/estimate/auto/advert/fotos', this.params).then(response => {
					//console.log(that.$options.name, 'onOK','response.data', response.data)
					//that.setItem(response.data)

					const data = response.data?.data;
					//console.log(that.$options.name, 'onOK', 'data', data)

					let files = []
					Object.entries(data).forEach(([akey, auto]) => {
						Object.entries(auto).forEach(([fkey, foto]) => {
							const url = foto?.formats[1];
							const filename = url.split('/').pop();

							//console.log(that.$options.name, 'onOK', 'url', url)
							//console.log(that.$options.name, 'onOK', 'filename', filename)

							that.urlToFile(url, filename, null).then(file => {
								//console.log(that.$options.name, 'onOK', 'file', file)
								files.push(file)
							}).catch(error => {
								console.error('Error converting URL to file:', error);
							});
						});
					});

					that.setItem({
						files: files
					})

					//console.log(that.$options.name, 'onOK','items', that.items)
				}, error => {
					console.log('error', error)

					that.snackbar.visible 	= true;
					that.snackbar.text 		= error.response.data.message;
					that.snackbar.color 	= null;
				}).finally(() => {
					this.loading = false
				});
			}
		},

		onPDF () {
			this.$refs.pdf.generate()
		},

		getFileUrl(file) {
			return URL.createObjectURL(file);
		},

		async urlToFile(url, filename, mimeType) {
			//console.log(this.$options.name, 'urlToFile','filename', filename)

			const response = await fetch(url);
			const blob = await response.blob();
			const type = mimeType || blob.type || response.headers.get('content-type');
			const file = new File([blob], filename, { type });

			//console.log(this.$options.name, 'urlToFile','file', file)

			return file;
		},

		download(file) {
			//console.log(this.$options.name, 'download','file', file)

			const blobUrl = URL.createObjectURL(file);

			// 3. Створюємо невидимий тег <a> і клікаємо по ньому
			const link = document.createElement('a');
			link.href = blobUrl;
			link.download = file.name || 'download.jpg';
			document.body.appendChild(link);
			link.click();

			document.body.removeChild(link);
			URL.revokeObjectURL(blobUrl);
		},

		/* async download(item) {
			const url = item.formats[1];
			const filename = url.split('/').pop();

			try {
				// 1. Отримуємо дані зображення як Blob
				const response = await fetch(url);
				const blob = await response.blob();

				// 2. Створюємо тимчасове посилання в пам'яті
				const blobUrl = URL.createObjectURL(blob);

				// 3. Створюємо невидимий тег <a> і клікаємо по ньому
				const link = document.createElement('a');
				link.href = blobUrl;
				link.download = filename || 'download.jpg';
				document.body.appendChild(link);
				link.click();

				// 4. Очищуємо пам'ять
				document.body.removeChild(link);
				URL.revokeObjectURL(blobUrl);
			} catch (error) {
				console.error("Помилка при завантаженні зображення:", error);
			}
		}, */

		onDownload(item) {
			this.download(item)
		},

		onDownloadAll() {
			this.files.forEach(file => this.download(file))
		},
	},
}
</script>